var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('BoardsError'),_c('Charger')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }